import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { Modal, Spinner, Button } from "react-bootstrap";
import DeleteConfirmationModal from "./delete-confirmation-modal";
import { toast } from "react-toastify";
import VideoPopover from "./video-popover";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const ViewQuestionsModal = ({ videoCode, onClose, isAdmin, hasEdit }) => {
    // const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    // const loadData = useCallback(() => {
    //     if (!videoCode) return;
    //     setLoading(true)
    //     axios.get(`${process.env.REACT_APP_API_URL}/video_guide?video_url=https://www.youtube.com/embed/${videoCode}`)
    //         .then((response) => {
    //             if (response.data) {
    //                 setData(response.data.data.subtopics);
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //         }).finally(() => {
    //             setLoading(false)
    //         })
    // }, [videoCode])


    const fetchQuestions = async () => {
        if(!videoCode) return [];
        const resp = await axios.get(`${process.env.REACT_APP_API_URL}/video_guide?video_url=https://www.youtube.com/embed/${videoCode}`)
        return resp.data.data.subtopics;
    }


    const queryClient = useQueryClient();

    const { data: questionsData = [], isLoading: questionsisLoading, isError: questionsIsError, isFetching: questionsIsFetching } = useQuery({
        queryKey: ['questions', videoCode],
        queryFn: fetchQuestions,
        enabled: !!videoCode,
    })

    useEffect(() => {
        setData(questionsData || []);
    }, [questionsData])

    const [editMode, setEditMode] = useState([]);   
    const [saving, setSaving] = useState([])
    const onSave = useCallback((val, key, isNew) => {
        if (!val.question?.trim()) {
            toast.error("Question cannot be empty.");
            return;
        }

        setSaving((prev) => [...prev, key])
        axios[isNew ? 'post' : 'put'](`${process.env.REACT_APP_API_URL}/video_guide/questions`, {
            video_url: `https://www.youtube.com/embed/${videoCode}`,
            ...val,
        })
            .then((response) => {
                setEditMode((prev) => prev.filter(v => v !== key))
                if (isNew) {
                    setData((prev) => {
                        const newData = [...prev]
                        const j = newData.findIndex(v => v.segmentId === val.segment_id);
                        newData[j].augmentation.hints[val.oeh_key].isNew = false;
                        return newData;
                    })
                }
                toast.success("Successfully saved the question modification.");
            })
            .catch((err) => {
                console.log(err);
                if (err.response?.data?.data?.includes("The question is unrelated to the chapter")) {
                    toast.error("The question is unrelated to the chapter");
                } else {
                    toast.error("Error saving the question modification.");
                }
            }).finally(() => {
                setSaving((prev) => prev.filter(v => v !== key))
            })
    }, [videoCode])

    const [deleteConfirmationData, setDeleteConfirmationData] = useState();
    const [deleting, setDeleting] = useState(false)
    const onDelete = useCallback((deleteData) => {
        setDeleting(true)
        const payload = {
            video_url: `https://www.youtube.com/embed/${videoCode}`,
            ...deleteData,
        };
        axios.delete(`${process.env.REACT_APP_API_URL}/video_guide/questions?${new URLSearchParams(payload).toString()}`)
            .then(() => {
                // loadData();
                queryClient.invalidateQueries(['questions', videoCode]);
                setDeleteConfirmationData()
                toast.success("Successfully removed the questions from the chapters.");
            })
            .catch((err) => {
                console.log(err)
                toast.error("Error removing the question modification.");
            }).finally(() => {
                setDeleting(false)
            })
    }, [videoCode])

    // Chapter content state
    const [chapterData, setChapterData] = useState([]);
    const [chapterLoading, setChapterLoading] = useState(false);
    const [chapterEditMode, setChapterEditMode] = useState([]);
    const [chapterSaving, setChapterSaving] = useState([]);
    const [videoPopoverData, setVideoPopoverData] = useState(null);
    const [videoPopoverTarget, setVideoPopoverTarget] = useState(null);

    // const loadChapterData = useCallback(() => {
    //     if (!videoCode) return;
    //     setChapterLoading(true);
    //     axios.get(`${process.env.REACT_APP_API_URL}/video_guide/content?video_url=https://www.youtube.com/embed/${videoCode}`)
    //         .then((response) => {
    //             if (response.data?.data?.data?.length) {
    //                 setChapterData(response.data.data.data);
    //             }
    //         })
    //         .catch((err) => console.log(err))
    //         .finally(() => setChapterLoading(false));
    // }, [videoCode]);

    // useEffect(() => { loadChapterData(); }, [videoCode]);

    const getChapterData = async () => {
        if(!videoCode) return [];
        const resp = await axios.get(`${process.env.REACT_APP_API_URL}/video_guide/content?video_url=https://www.youtube.com/embed/${videoCode}`)
        return resp.data.data.data;
    }
    const {
        data: chaptersData = [],
        isLoading: chaptersisLoading,
        isError: chaptersIsError,
        isFetching: chaptersIsFetching,
        }=useQuery({
        queryKey: ['chapterContent', videoCode],
        queryFn: getChapterData,
        enabled: !!videoCode,
    })

    useEffect(() => {
        setChapterData(chaptersData || []);
    }, [chaptersData])

    const onChapterSave = useCallback((val, i) => {
        setChapterSaving((prev) => [...prev, i]);
        axios.put(`${process.env.REACT_APP_API_URL}/video_guide/content`, {
            video_url: `https://www.youtube.com/embed/${videoCode}`,
            data: [{ serial_number: val.serial_number, start_time: val.start_time, end_time: val.end_time, content: val.content }],
        })
            .then(() => {
                setChapterEditMode((prev) => prev.filter(v => v !== i));
                queryClient.invalidateQueries(['chapterContent', videoCode]);
                toast.success("Successfully saved the chapter content modification.");
            })
            .catch(() => toast.error("Error saving the chapter content modification."))
            .finally(() => setChapterSaving((prev) => prev.filter(v => v !== i)));
    }, [videoCode, queryClient]);

    const [chapterDeleteIndex, setChapterDeleteIndex] = useState();
    const [chapterDeleting, setChapterDeleting] = useState(false);

    const onChapterDelete = useCallback((i) => {
        setChapterDeleting(true);
        const val = chapterData[i];
        const payload = {
            video_url: `https://www.youtube.com/embed/${videoCode}`,
            serial_number: val.serial_number,
        };
        axios.delete(`${process.env.REACT_APP_API_URL}/video_guide/content?${new URLSearchParams(payload).toString()}`)
            .then(() => {
                // loadChapterData();
                // refetchChapters();
                queryClient.invalidateQueries(['chapterContent', videoCode]);
                setChapterDeleteIndex();
                toast.success("Successfully removed the content.");
            })
            .catch(() => toast.error("Error removing the content."))
            .finally(() => setChapterDeleting(false));
    }, [videoCode, chapterData]);

    return (
        <>
            <VideoPopover
                targetRef={videoPopoverTarget}
                startTime={videoPopoverData?.start_time}
                endTime={videoPopoverData?.end_time}
                videoId={videoCode}
                onClose={() => { setVideoPopoverTarget(null); setVideoPopoverData(null); }}
            />
            <Modal show onHide={onClose} centered size="xl" style={{ zIndex: 10000 }} dialogClassName="modal-95w">
                <Modal.Header closeButton>
                    <Modal.Title style={{ display: "flex", width: "100%", gap: "24px" }}>
                        <span style={{ flex: 1, color: "#2e65ae" }}>View Questions</span>
                        <span style={{ flex: 1, paddingLeft: "24px", color: "#2e65ae" }}>Chapter Content</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: 0 }}>
                    <div style={{ display: "flex" }}>
                    <div style={{ flex: 1, minWidth: 0, overflowY: "auto", maxHeight: "75vh", padding: "16px" }}>
                    {questionsisLoading && <div style={{ margin: "40px 0" }}> 
                          <Button
                            variant="link"
                            className="mt-2 mb-5 btn-spinner ms-0 text-decoration-none"
                            disabled
                          >
                            <Spinner
                              as="span"
                              animation="grow"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              className="me-1"
                            />
                          </Button></div>}
                    {questionsIsError && <p>Something went wrong while fetching questions</p> }
                    {!questionsIsError && !questionsIsFetching && !data?.length && "No questions found"}
                    {data.map((row, j) => (
                        <div key={row.segmentId} style={{ margin: '16px 0' }}>
                            <div style={{ fontWeight: 'bold' }}>{row.heading}</div>
                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '8px' }}>
                                <ol style={{ marginBottom: '0' }}>
                                    {Object.entries(row.augmentation.hints).map(([key, val], i) => (
                                        <li key={key}>
                                            <div style={{ display: 'flex', gap: '8px', alignItems: "start", marginBottom: '8px', whiteSpace: "pre-wrap", }}>
                                                {!editMode.includes(`${row.segmentId}_${key}`) ?
                                                    <>
                                                        <div className="me-auto">
                                                            {val.hint}
                                                            {/* <br />
                                                            {val.answer} */}
                                                        </div>
                                                        {(isAdmin || hasEdit) &&
                                                        <img
                                                            style={{ cursor: 'pointer' }}
                                                            src={"/images/edit.svg"}
                                                            alt="edit"
                                                            onClick={() => setEditMode((prev) => [...prev, `${row.segmentId}_${key}`])}
                                                        />
                                                        }
                                                        {(isAdmin || hasEdit) &&
                                                        <img
                                                            style={{ cursor: 'pointer' }}
                                                            src={"/images/delete-grey.svg"}
                                                            alt="trash"
                                                            onClick={() => setDeleteConfirmationData({ segment_id: row.segmentId, oeh_key: key })}
                                                        />
                                                         }
                                                        </>
                                                    :
                                                    <>
                                                        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "8px" }}>
                                                            <textarea
                                                                style={{ width: "100%", border: '1px solid gray' }}
                                                                disabled={saving.includes(i)}
                                                                value={val.hint}
                                                                placeholder="Enter Question"
                                                                onChange={(e) => {
                                                                    setData((prev) => {
                                                                        const newData = [...prev]
                                                                        newData[j].augmentation.hints[key].hint = e.target.value;
                                                                        return newData;
                                                                    })
                                                                }}
                                                            />
                                                            {/* <textarea
                                                                style={{ width: "100%", border: '1px solid gray' }}
                                                                disabled={saving.includes(i)}
                                                                value={val.answer}
                                                                onChange={(e) => {
                                                                    setData((prev) => {
                                                                        const newData = [...prev]
                                                                        newData[j].augmentation.hints[key].answer = e.target.value;
                                                                        return newData;
                                                                    })
                                                                }}
                                                            /> */}
                                                        </div>
                                                        {saving.includes(`${row.segmentId}_${key}`)
                                                            ? <Spinner animation="border" size="sm" />
                                                            : <img
                                                                style={{ cursor: 'pointer' }}
                                                                src={"/images/save.svg"}
                                                                alt="save"
                                                                onClick={() => saving.includes(`${row.segmentId}_${key}`) ? {} : onSave({
                                                                    oeh_key: key,
                                                                    segment_id: row.segmentId,
                                                                    question: val.hint,
                                                                    // answer: val.answer,
                                                                }, `${row.segmentId}_${key}`, val.isNew)}
                                                            />}
                                                    </>
                                                }
                                            </div>
                                        </li>
                                    ))}
                                </ol>
                                {(isAdmin || hasEdit) && Object.entries(row.augmentation.hints).length < 3 && <>
                                    <button
                                        className="btn btn-outline-secondary"
                                        style={{ width: "fit-content", minHeight: '20px', padding: '4px 10px', marginLeft: '32px' }}
                                        onClick={() => {
                                            setData((prev) => {
                                                const newData = [...prev]
                                                const key = getNewOEHKey(newData[j].augmentation.hints);
                                                newData[j].augmentation.hints[key] = { isNew: true, hint: "" }
                                                setEditMode((prev) => [...prev, `${row.segmentId}_${key}`]);
                                                return newData;
                                            })
                                        }}
                                    >Add Question</button>
                                </>}
                            </div>
                        </div>
                    ))}
                    </div>

                    {/* Right: Chapter Content */}
                    <div style={{ flex: 1, minWidth: 0, borderLeft: "1px solid #dee2e6", overflowY: "auto", maxHeight: "75vh", padding: "16px" }}>
                            {chaptersisLoading && <div style={{ margin: "40px 0" }}>
                                <Button
                                    variant="link"
                                    className="mt-2 mb-5 btn-spinner ms-0 text-decoration-none"
                                    disabled
                                >
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-1"
                                    />
                                </Button></div>}
                        {chaptersIsError && <p>Something went wrong while fetching chapter content</p>}
                        {!chaptersIsError && !chaptersIsFetching && !chapterData?.length && "No contents found"}
                        {chapterData?.map((val, i) => (
                            <div key={i} style={{ margin: '16px 0' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
                                    <span style={{ fontWeight: 'bold', flex: 1 }}>{i + 1}. {val.heading}</span>
                                    {/* <img
                                        style={{ cursor: "pointer" }}
                                        src="/images/play-circle.svg"
                                        alt="play"
                                        onClick={(e) => { setVideoPopoverTarget(e.target); setVideoPopoverData(val); }}
                                    /> */}
                                    {(isAdmin || hasEdit) && (
                                        chapterSaving.includes(i)
                                            ? <Spinner animation="border" size="sm" />
                                            : chapterEditMode.includes(i)
                                                ? <img style={{ cursor: "pointer" }} src="/images/save.svg" alt="save" onClick={() => onChapterSave(val, i)} />
                                                : <img style={{ cursor: "pointer" }} src="/images/edit.svg" alt="edit" onClick={() => setChapterEditMode((prev) => [...prev, i])} />
                                    )}
                                    {(isAdmin || hasEdit) && !chapterEditMode.includes(i) &&
                                        <img style={{ cursor: 'pointer' }} src="/images/delete-grey.svg" alt="trash" onClick={() => setChapterDeleteIndex(i)} />
                                    }
                                </div>
                                {/* Content */}
                                {chapterEditMode.includes(i) ? (
                                    <textarea
                                        rows={4}
                                        style={{ width: "100%", border: "1px solid gray" }}
                                        disabled={chapterSaving.includes(i)}
                                        value={val.content}
                                        onChange={(e) => setChapterData((prev) => {
                                            const newData = [...prev];
                                            newData[i] = { ...newData[i], content: e.target.value };
                                            return newData;
                                        })}
                                    />
                                ) : (
                                    <div style={{ whiteSpace: "pre-wrap", fontSize: "14px" }}>{val.content}</div>
                                )}
                            </div>
                        ))}
                    </div>
                    </div>
                </Modal.Body>
            </Modal>
            {!!deleteConfirmationData &&
                <DeleteConfirmationModal
                    loading={deleting}
                    onClose={() => setDeleteConfirmationData()}
                    onConfirm={() => onDelete(deleteConfirmationData)}
                />
            }
            {chapterDeleteIndex >= 0 &&
                <DeleteConfirmationModal
                    loading={chapterDeleting}
                    onClose={() => setChapterDeleteIndex()}
                    onConfirm={() => onChapterDelete(chapterDeleteIndex)}
                />
            }
        </>
    );
}

const getNewOEHKey = (existingData) => {
    const keys = ["OEH1", "OEH2", "OEH3"];
    for (const key of keys) {
        if (!existingData[key]) {
            return key;
        }
    }
    return null;
}

export default ViewQuestionsModal;